import {ValueObject} from '@s-ui/domain'

import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class CubicCapacitySpecificationVehiclesValueObject extends ValueObject {
  #cubicCapacity

  constructor({cubicCapacity}) {
    super()
    this.#cubicCapacity = cubicCapacity
  }

  static CC_SUFFIX = 'cc'

  static empty() {
    return new CubicCapacitySpecificationVehiclesValueObject({cubicCapacity: SpecificationVehiclesValueObject.empty()})
  }

  static ccString({cc}) {
    return `${cc} ${CubicCapacitySpecificationVehiclesValueObject.CC_SUFFIX}`
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id})) return CubicCapacitySpecificationVehiclesValueObject.empty()

    return new CubicCapacitySpecificationVehiclesValueObject({
      cubicCapacity: SpecificationVehiclesValueObject.createFromLiterals({
        id,
        name: CubicCapacitySpecificationVehiclesValueObject.ccString({cc: id})
      })
    })
  }

  get icon() {
    return this.#cubicCapacity.icon
  }

  get id() {
    return this.#cubicCapacity.id
  }

  get name() {
    return this.#cubicCapacity.name
  }

  get value() {
    return this.#cubicCapacity.value
  }

  isEmpty() {
    return this.#cubicCapacity.isEmpty()
  }
}
